import Big from "big.js";
import React from "react";
import { ReactNode } from "react-markdown";
import { connect } from 'react-redux';
import { Redirect } from "react-router";
import { Dispatch } from 'redux';
import { AppState } from "../../RootReducer";
import { CurrencyDefinition, DepositResult, DepositResultCode, PaymentDialog, Settings, VoucherRedemptionResultCode } from "../../http/protocol";
import { t } from "../../i18n";
import { getContainer } from "../../ioc/IOCSetup";
import TextField from "../../layout/TextField";
import { showDepositResult } from "../../payments/DepositActions";
import { DepositPhase, DepositState } from "../../payments/PaymentsReducer";
import { getCurrencyDefinitions } from "../../selectors/settings-selectors";
import CurrencyFormatter from "../../utils/CurrencyFormatter";
import getLoggedInRedirect from "../../utils/LoggedInRedirect";
import { BrandA } from "../buttons/buttons";


interface Props {
    type: string
    handleClickStartPlaying?: () => void;
    deposit? : DepositState;
    dialog? : PaymentDialog;
    settings?: Settings;
    redeemResult: (depositResult: DepositResult) => void;
    currencies: CurrencyDefinition[]
}

interface State {
    startPlaying:boolean;
    loading: boolean;
    code: string;
    message: string;
    isError: boolean;
}

type AllProps = Props


class VoucherPaymentComponent extends React.Component<AllProps, State> {

    paymentService = getContainer().getPaymentsService()

    constructor(props:AllProps) {
        super(props);

        this.state = {startPlaying:false, loading: false, code: "", message: "sdf", isError: false}
    }


    async redeem() {

        var depositResult
        var message

        try {
            var res = await this.paymentService.redeemVoucher(this.state.code);

            if (res.code == VoucherRedemptionResultCode.FAILURE) {
                depositResult = DepositResultCode.ERROR
                message = t("payments.method.voucher.deposit.error")
            } else {
                depositResult = DepositResultCode.OK

                const cur = this.props.currencies.find(c => c.code == res.currency)

                const amount = CurrencyFormatter.formatWithSymbol(cur, Big(res.amount!),true)
                message = t("payments.method.voucher.deposit.success", {amount: amount})
            }

        } catch (err) {
            depositResult = DepositResultCode.ERROR
            message = t("payments.method.voucher.deposit.error")
        }

        this.props.redeemResult({
            message: message,
            result: depositResult
        });


    }


    componentDidUpdate(prevProps: AllProps, nextState: State) {
    }


    renderDeposit() {
        const phase = this.props.deposit && this.props.deposit.phase;
        const dialog = this.props.dialog;
        const isError = this.props.deposit?.depositResult?.result == DepositResultCode.ERROR

        return(
            <div>
                {phase === DepositPhase.PROVIDER_CONTENT && (
                    <div>
                        <TextField placeholder={t("payments.method.voucher.deposit.enterCodeInputPlaceholder")} onChange={(e) => this.setState({code: e.target.value})} type="text" />

                        <BrandA className={"btn btn-cta full-width large"} 
                                onClick={() => this.redeem()} disabled={this.state.loading  ||  this.state.code.length < 1}>
                                {t("payments.method.voucher.deposit.redeemButton")}
                        </BrandA>
                    </div>
                )}

                {phase === DepositPhase.DEPOSIT_RESULT  &&  isError  && (
                    <>
                        <div className="alert alert-danger">{this.props.deposit?.depositResult?.message}</div>
                    </>
                )}

                {phase === DepositPhase.DEPOSIT_RESULT  &&  !isError  && (
                    <>
                        <div className="alert alert-success">{this.props.deposit?.depositResult?.message}</div>
                        {this.props.handleClickStartPlaying && 
                            <BrandA className={"btn btn-cta full-width large"} onClick={this.props.handleClickStartPlaying}>{t("global.startPlaying")}</BrandA>
                        }
                    </>
                )}
            </div>
        )        
    }

    render(): ReactNode | ReactNode[]  {
        if(this.state.startPlaying && this.props.settings) {
            return <Redirect to={getLoggedInRedirect(this.props.settings)} />
        }

        if(this.props.type == "withdraw") {
            return <></>
        }
        if(this.props.type == "deposit") {
            return  this.renderDeposit()
        }
    }
}

const mapDispatchToProps = (dispatch: Dispatch)=> ({
    // initDeposit : () => dispatch(initDeposit() as any)
    redeemResult: (depositResult: DepositResult) => dispatch(showDepositResult(depositResult) as any)
});

const mapStateToProps = (state: AppState) => (
    {currencies: getCurrencyDefinitions(state)}
)

export default connect(mapStateToProps, mapDispatchToProps)(VoucherPaymentComponent as any) as any;